//生成权限树
export function createTree(data){
    let api = data.API;
    let menu = data.menu;
    let treeData = [];
    _.map(api, (item, index) => {
        //获取内部导航栏
        let moduleArr=[];
        _.map(item.module,(item,index)=>{
            let btnArr=[];
            _.map(item.apiList,(item,index)=>{
                let itemArr={
                    id:item.key,
                    label:item.name,
                    api:item.API
                }
                btnArr.push(itemArr)
            })
            let modelItem={
                id:item.value,
                label:item.name,
                children:btnArr
            }
            moduleArr.push(modelItem)
        })

        //获取一级菜单
        let arr={
            id:item.$menu,
            label:menu[item.$menu].title,
            children:moduleArr
        }
        
        treeData.push(arr);
    });
    return treeData;
}

//处理权限
export function getAssess(data){
    let array=[]
    for(let i=0;i<data.length;i++){
        array.push(data[i].key)
    }
    return array
}



// WEBPACK FOOTER //
// ./src/utils/assess.js